import config from '../../../app/config';
import axios from 'axios';

export class AttendanceAPI {
    static ReportsApiName = "apiReports";
    static DefaultApiName = "apiUrlAgyle";
    static AttServiceApiName = "apiAttService";
    static getAttendances(filter, api= AttendanceAPI.ReportsApiName) {
        return new Promise(async function (resolve, reject) {
            if(config.hasOwnProperty(api)) {
                let url = `${(config[api].endsWith("/") ? config[api] : config[api] + "/")}attendances_to_closure?date_from=${filter.dateFrom}&date_to=${filter.dateTo}&type=E`;
                axios.get(url).then((response) => {
                    //console.log("tableName: " + tableName, response.data);
                    resolve(response);
                }).catch(error => {
                    if (error?.message !== "canceled") {
                        reject(error);
                    }
                });
            } else {
                reject(`incorrect api name [${api}], missing in config`);
            }
            // TODO: error handling ???
        });
    }

    static closeAttendance(id, api= AttendanceAPI.DefaultApiName) {
        return new Promise(async function (resolve, reject) {
            if(config.hasOwnProperty(api)) {
                let url = `${(config[api].endsWith("/") ? config[api] : config[api] + "/")}attendances/setAttendanceManualClose`;
                axios.post(url, {__id:id}).then((response) => {
                    //console.log("tableName: " + tableName, response.data);
                    resolve(response);
                }).catch(error => {
                    if (error?.message !== "canceled") {
                        reject(error);
                    }
                });
            } else {
                reject(`incorrect api name [${api}], missing in config`);
            }
            // TODO: error handling ???
        });
    }

    static moveAttendance(id,patientId,newPatientId, api= AttendanceAPI.AttServiceApiName) {
        return new Promise(async function (resolve, reject) {
            if(config.hasOwnProperty(api)) {
                let url = `${(config[api].endsWith("/") ? config[api] : config[api] + "/")}move_attendance`;
                axios.post(url, {"patientId":patientId,"attendanceId":id,"newPatientId" : newPatientId})
                    .then((response) => {
                    //console.log("tableName: " + tableName, response.data);
                    resolve(response);
                }).catch(error => {
                    if (error?.message !== "canceled") {
                        reject(error);
                    }
                });
            } else {
                reject(`incorrect api name [${api}], missing in config`);
            }
            // TODO: error handling ???
        });
    }
}
